import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Background from '../../components/Background/Background'
import FlexSection from '../../components/FlexSection/FlexSection'
import CustomSlider from '../../components/CustomSlider/CustomSlider'
import Title from '../../components/Title/Title'
import SelectedSex from '../../components/SelectedSex/SelectedSex'

const CURRENT_STEP_NUMBER = 4
const NEXT_STEP_URL = 'hvor-mye'

class Often extends Component {
  constructor (props) {
    super(props)
    this.state = {
      timesPrDay: 3
    }
    this.onSliderChange = this.onSliderChange.bind(this)
    this.onAfterSliderChange = this.onAfterSliderChange.bind(this)
  }

  componentDidMount () {
    this.props.initStep(CURRENT_STEP_NUMBER, NEXT_STEP_URL)
  }

  onSliderChange (value) {
    this.setState({ timesPrDay: value })
  }

  onAfterSliderChange (value, id) {
    let timesPrWeek = value + (value === 1 ? ' gang' : ' ganger')
    if (value >= 3) value += 100
    this.props.updateScore(value, id, CURRENT_STEP_NUMBER, timesPrWeek)
  }

  render () {
    const { selectedSex } = this.props
    const { timesPrDay } = this.state

    return (
      <Background color="#5EACC2">
        <FlexSection>
          <Title>
            Hvor ofte tisser <SelectedSex selectedSex={selectedSex} /> i senga per uke?
          </Title>
          <div className="scale-1-5">
            <img className="w-75" src={`/images/tall/${timesPrDay}.svg`} alt="" />
          </div>
          <div className="secondary-color primary-font-bold mv2 f2">
            {timesPrDay === 1 ? 'gang' : 'ganger'}
          </div>
          <div className="flex justify-between w-80 mt3 mb1">
            <CustomSlider
              onAfterSliderChange={this.onAfterSliderChange}
              onSliderChange={this.onSliderChange}
              id={1}
              min={1}
              max={7}
              defaultValue={3}
            />
          </div>
        </FlexSection>
      </Background>
    )
  }
}

Often.propTypes = {
  updateScore: PropTypes.func.isRequired,
  selectedSex: PropTypes.string
}

export default Often



// WEBPACK FOOTER //
// ./src/containers/Often/Often.js